<template>
  <div class="nikke-aside">
    <!--点赞-->
    <div class="aside-item" @click="onLike">
      <img
        class="icon"
        :src="
          `${
            detail.is_like
              ? require('@/assets/images/aside_dianzanle.png')
              : require('@/assets/images/aside_dianzan.png')
          }`
        "
        alt="点赞"
      />
      <span class="txt">{{ formatCount(detail.like_count) }}</span>
    </div>
    <!--收藏-->
    <div class="aside-item" @click="onFavorite">
      <img
        class="icon"
        :src="
          `${
            detail.is_favorite
              ? require('@/assets/images/aside_shoucangle.png')
              : require('@/assets/images/aside_shoucang.png')
          }`
        "
        alt="收藏"
      />
      <span class="txt">{{ formatCount(detail.favorite_count) }}</span>
    </div>
    <!--评论-->
    <div class="aside-item" @click="onComment">
      <img class="icon" :src="`${require('@/assets/images/aside_pinglun.png')}`" alt="评论"/>
      <span class="txt">{{ formatCount(detail.comment_count) }}</span>
    </div>
    <!--分享-->
    <div class="aside-item" @click="$emit('share')">
      <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`" alt="分享"/>
      <span class="txt">分享</span>
    </div>
    <!--图鉴编辑-->
    <div class="aside-item"  @click="goTJEdit" v-if="loginUser.is_super">
      <svg class="icon" width="28" height="28" viewBox="0 0 28 28">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.08 4.33163C15.0408 4.2936 14.9783 4.29408 14.9397 4.33271L12.2899 6.98245L17.3981 11.8287C17.7587 12.1708 17.7737 12.7404 17.4316 13.101C17.0895 13.4616 16.5199 13.4766 16.1593 13.1345L11.0167 8.25569L3.9289 15.3435C3.91015 15.3623 3.89961 15.3877 3.89961 15.4142V22C3.89961 22.0552 3.94438 22.1 3.99961 22.1H13.6694L23.4145 12.5565C23.4547 12.5171 23.4545 12.4524 23.4142 12.4132L15.08 4.33163ZM16.242 22.1L24.6739 13.8425C25.4374 13.0948 25.4343 11.8649 24.6672 11.121L16.3331 3.03941C15.5879 2.31685 14.4008 2.32598 13.6669 3.05992L2.65611 14.0707C2.29979 14.427 2.09961 14.9103 2.09961 15.4142V22C2.09961 23.0493 2.95027 23.9 3.99961 23.9H14.0366H25.0737V22.1H16.242Z"
          fill="#555555"
        />
      </svg>
      <span class="txt">编辑</span>
    </div>
    <div class="aside-item"  @click="goLive2dPosition" v-if="loginUser.is_super">
      <svg class="icon" width="28" height="28" viewBox="0 0 28 28">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.08 4.33163C15.0408 4.2936 14.9783 4.29408 14.9397 4.33271L12.2899 6.98245L17.3981 11.8287C17.7587 12.1708 17.7737 12.7404 17.4316 13.101C17.0895 13.4616 16.5199 13.4766 16.1593 13.1345L11.0167 8.25569L3.9289 15.3435C3.91015 15.3623 3.89961 15.3877 3.89961 15.4142V22C3.89961 22.0552 3.94438 22.1 3.99961 22.1H13.6694L23.4145 12.5565C23.4547 12.5171 23.4545 12.4524 23.4142 12.4132L15.08 4.33163ZM16.242 22.1L24.6739 13.8425C25.4374 13.0948 25.4343 11.8649 24.6672 11.121L16.3331 3.03941C15.5879 2.31685 14.4008 2.32598 13.6669 3.05992L2.65611 14.0707C2.29979 14.427 2.09961 14.9103 2.09961 15.4142V22C2.09961 23.0493 2.95027 23.9 3.99961 23.9H14.0366H25.0737V22.1H16.242Z"
          fill="#555555"
        />
      </svg>
      <span class="txt">live2d位置</span>
    </div>
  </div>
</template>
<script>
import {apiContentLike} from "@/api/contentApi";
import {apiUserAddFavorite} from "@/api/userApi";
import {debounce} from "@/plugins/util";
import { mapGetters } from "vuex";
import eventBus from "@/plugins/eventBus";

export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    commentList: {
      type: Array,
      default: () => []
    },
    commentPagination: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: Number,
      require: false,
      default: 1
    },
  },
  computed: {
    ...mapGetters(["loginUser"])
  },
  methods: {
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    },
    onLike: debounce(function () {
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: this.type
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      })
    }, 100),
    onFavorite() {
      if (!this.isLoginShow()) {
        return false
      }
      let params = {
        origin_id: this.detail.id,
        type: this.type
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code === 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      })
    },
    onComment() {
      this.$emit("comment");
    },
    // 获取评论列表
    getCommentList(type) {
      this.$emit("getCommentList", type);
    },
    goTJEdit(){
      let path = "";
      // 图鉴
      if (this.detail.editor_type == 3) {
        path = `/${this.alias}/rich-table?id=${this.detail.id}&entry_id=${this.detail.entry_id}&title=${this.detail.title}&isDetailEdit=true`;
      } else {
        return;
      }
      if (!this.isLoginShow("")) {
        sessionStorage.setItem("login_jump_path", path);
        return false;
      }

      if (!this.isAuthRealName()) {
        sessionStorage.setItem("login_jump_path", path);
        return false;
      }
      this.$router.push(path);
    },
    refresh(detail, user) {
      this.$emit("refresh", detail, user);
    },
    goLive2dPosition() {
      eventBus.$emit("live2dPosition");
    }
  }
}
</script>

<style scoped lang="less">
.nikke-aside {
  position: absolute;
  right: 0;
  top: 80px;
  z-index: 1000;
  width: 58px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  .aside-item {
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 3px;
    cursor: pointer;
    border: 1px solid #d1cfd4;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.3);
    .icon {
      width: 20px;
      height: 20px;
    }

    .txt {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #142630;
    }
  }
}
</style>
